import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/achievements.css';

export default class Achievements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedItem: null,
      activeTab: 'certificates' // 'certificates' or 'achievements'
    };
  }

  // Certificate data
  certificates = [
    {
      id: 1,
      title: "Accreditation of Tour Operators",
  issuer: "Department of Tourism, Government of Kerala",
  year: "2026",
  type: "pdf",
  file: "/assets/certificates/AccreditationCertificate.jpeg",
  thumbnail: "/assets/img/ato_logo.png",
  description: "Officially accredited by the Department of Tourism, Government of Kerala, recognizing Kairaly Hotels & Holidays as an Accredited Tour Operator committed to delivering quality, reliable, and professional tourism services."
    },
{
  id: 2,
  title: "Kerala Responsible Tourism Certification",
  issuer: "Kerala Responsible Tourism Mission, Government of Kerala",
  year: "2023",
  type: "pdf",
  file: "/assets/certificates/rtcert.jpeg",
  thumbnail: "/assets/img/RTLOGO.jpg",
  description: "Recognized under Kerala Responsible Tourism Mission for promoting sustainable, eco-friendly, and community-based tourism practices."
},
    {
      id: 3,
      title: "NIDHI REGISTRATION CERTIFICATE",
      issuer: "Ministry of Tourism, Government of India",
      year: "2023",
      type: "pdf",
      file: "/assets/certificates/Nidhi.jpeg",
      thumbnail: "/assets/img/nidhi.jpg",
      description: "FOR COMMITMENT TOWARDS SAFE & HONOURABLE TOURISM AND SUSTAINABLE TOURISM"
    },
    {
  id: 4,
  title: "UDYAM REGISTRATION CERTIFICATE",
  issuer: "Ministry of Micro, Small and Medium Enterprises, Government of India",
  year: "2023",
  type: "pdf",
  file: "/assets/certificates/Udhyam.jpeg",
  thumbnail: "/assets/img/udyam.jpeg",
  description: "Official recognition under UDYAM registration for Micro, Small and Medium Enterprises, ensuring credibility, compliance, and government recognition."
},
    {
  id: 5,
  title: "IRCTC Authorised Rail E-Ticketing Centre",
  issuer: "Indian Railway Catering and Tourism Corporation (IRCTC), Government of India",
  year: "2023",
  type: "pdf",
  file: "/assets/certificates/irctc.jpeg",
  thumbnail: "/assets/img/IRCTC_Logo.png",
  description: "Authorised IRCTC Rail E-Ticketing Centre, enabling secure and reliable railway ticket booking services across India."
},
    {
  id: 6,
  title: "Travel for LiFE – Signed Up Certificate",
  issuer: "Ministry of Tourism, Government of India",
  year: "2023",
  type: "pdf",
  file: "/assets/certificates/life.jpeg",
  thumbnail: "/assets/img/LiFE.png",
  description: "Recognized under the Travel for LiFE initiative, committing to sustainable tourism practices that positively impact the environment, society, culture, and economy."
}
  ];

  // Achievements data with full images
  achievements = [
    {
      id: 1,
      title: "Micro, Small & Medium Entrprices",
      description: "Kairaly Holidays is proudly recognized as an MSME (Micro, Small & Medium Enterprises) certified organization by the Government of India, reflecting our commitment to quality, reliability, and professional excellence.",
      image: "/assets/img/msme.png",
      count: "MSME",
      category: "Quality"
    },
    {
      id: 2,
      title: "Kerala Responsible Tourism Certified",
      description: "Recognized under Kerala Responsible Tourism Initiative for promoting sustainable and community-based tourism experiences.",
      image: "/assets/img/RTLOGO.jpg",
      count: "Govt. Approved",
      category: "Recognition"
    },
    {
        id: 3,
        title: "NIDHI Registered",
        description: "Registered under the National Integrated Database of Hospitality Industry (NIDHI), an initiative by the Ministry of Tourism, Government of India.",
        image: "/assets/img/nidhi.jpg",
        count: "Govt. Recognized",
        category: "Hospitality"
    },
    // {
    //   id: 4,
    //   title: "50+ Destinations",
    //   description: "Exploring the best of South India",
    //   image: "/assets/achievements/destinations.png",
    //   count: "50+",
    //   category: "Destinations"
    // },
    // {
    //   id: 5,
    //   title: "24/7 Support",
    //   description: "Round-the-clock customer assistance",
    //   image: "/assets/achievements/support.png",
    //   count: "24/7",
    //   category: "Support"
    // },
    // {
    //   id: 6,
    //   title: "100% Satisfaction",
    //   description: "Commitment to quality service",
    //   image: "/assets/achievements/satisfaction.png",
    //   count: "100%",
    //   category: "Satisfaction"
    // }
  ];

  openModal = (item) => {
    this.setState({
      showModal: true,
      selectedItem: item
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      selectedItem: null
    });
  };

    renderCertificateCard = (cert) => {
    return (
      <div key={cert.id} className="certificate-card" onClick={() => this.openModal(cert)}>
        <div className="certificate-thumbnail">
          <img src={cert.thumbnail} alt={cert.title} />
          <div className="certificate-overlay">
            <i className="fas fa-file-pdf"></i>
            <span>View Certificate</span>
          </div>
        </div>
        <div className="certificate-info">
          <h4 className="certificate-title">{cert.title}</h4>
          <p className="certificate-issuer">
            <i className="fas fa-building"></i> {cert.issuer}
          </p>
          <p className="certificate-year">
            <i className="fas fa-calendar-alt"></i> {cert.year}
          </p>
          <p className="certificate-description">{cert.description}</p>
          <button className="view-certificate-btn" onClick={(e) => {
            e.stopPropagation();
            this.openModal(cert);
          }}>
            <i className="fas fa-eye"></i> View Certificate
          </button>
        </div>
      </div>
    );
  };

  renderAchievementCard = (achievement) => {
    return (
      <div key={achievement.id} className="achievement-card">
        <div className="achievement-image-wrapper">
          <img 
            src={achievement.image} 
            alt={achievement.title}
            className="achievement-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://via.placeholder.com/200x150?text=" + achievement.title;
            }}
          />
        </div>
        <div className="achievement-content">
          <h3 className="achievement-count">{achievement.count}</h3>
          <h4 className="achievement-title">{achievement.title}</h4>
          <p className="achievement-description">{achievement.description}</p>
        </div>
      </div>
    );
  };

  render() {
    const { activeTab, showModal, selectedItem } = this.state;

    return (
      <div className="achievements-section">
        <div className="section-header">
          <h2 className="section-title">Our Achievements & Certifications</h2>
          <p className="section-subtitle">
            Recognized for excellence and commitment to quality travel services
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="tab-navigation">          
          <button
            className={`tab-btn ${activeTab === 'certificates' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'certificates' })}
          >
            <i className="fas fa-certificate"></i>
            <span>Certificates & Awards</span>
          </button>
          <button
            className={`tab-btn ${activeTab === 'achievements' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'achievements' })}
          >
            <i className="fas fa-trophy"></i>
            <span>Key Achievements</span>
          </button>
        </div>

        {/* Achievements Grid */}
        {activeTab === 'achievements' && (
          <div className="achievements-grid-container">
            <Grid>
              <Row>
                {this.achievements.map((achievement) => (
                  <Col xs={12} sm={6} md={4} key={achievement.id} className="achievement-col">
                    {this.renderAchievementCard(achievement)}
                  </Col>
                ))}
              </Row>
            </Grid>
          </div>
        )}

        {/* Certificates Grid */}
        {activeTab === 'certificates' && (
          <div className="certificates-grid-container">
            <Grid>
              <Row>
                {this.certificates.map((cert) => (
                  <Col xs={12} sm={6} md={4} lg={3} key={cert.id} className="certificate-col">
                    {this.renderCertificateCard(cert)}
                  </Col>
                ))}
              </Row>
            </Grid>
          </div>
        )}

        {/* Custom Modal - No React Bootstrap Modal */}
        {showModal && selectedItem && (
          <div className="custom-modal-overlay" onClick={this.closeModal}>
            <div className="custom-modal-container" onClick={(e) => e.stopPropagation()}>
              <div className="custom-modal-header">
                <h3>{selectedItem.title}</h3>
                <button className="close-modal-btn" onClick={this.closeModal}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="custom-modal-body">
                <div className="certificate-preview">
                  <iframe
                    src={selectedItem.file}
                    title={selectedItem.title}
                    width="100%"
                    height="500px"
                    style={{ border: 'none' }}
                  />
                </div>
                <div className="certificate-info-modal">
                  <p><strong>Issuer:</strong> {selectedItem.issuer}</p>
                  <p><strong>Year:</strong> {selectedItem.year}</p>
                  <p><strong>Description:</strong> {selectedItem.description}</p>
                  {/* <a href={selectedItem.file} download className="download-certificate-btn">
                    <i className="fas fa-download"></i> Download Certificate
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}